import { Component, effect, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';

import { filter } from 'rxjs/operators';
import { MenuSignal } from '../../signal';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-head',
    imports: [RouterLink],
    templateUrl: './head.component.html',
    styleUrls: ['./head.component.scss']
})
export class HeadComponent {
    readonly menuSignal = inject(MenuSignal)
    readonly router = inject(Router);
    readonly fall = signal(true);

    style?: string;
    height?: string;

    readonly navigationEnd = toSignal(
        this.router.events.pipe(filter(event => event instanceof NavigationEnd))
    );

    constructor() {
        effect(() => {
            const status = this.menuSignal.toggle();
            this.fall.set(!status);
        });

        effect(() => {
            this.navigationEnd(); // read signal to react
            this.fall.set(true);
        });
    }
}
